module.exports = __webpack_public_path__ + "img/nhai.b62f3498.png";